import { phpApi } from "../../../api";

export const fetchLists = () => {
  return phpApi.get("/api/survey/list");
};
